// src/pages/PaymentAmount.js

import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    Stack,
} from '@mui/material'

const PaymentAmount = () => {
    const navigate = useNavigate()
    const { state } = useLocation()

    const provider = state?.provider
    const paymentProfile = state?.paymentProfile

    const [amount, setAmount] = useState('')

    if (!provider) {
        navigate('/payment')
        return null
    }

    const goConfirm = () => {
        navigate('/payment/confirm', {
            state: { provider, amount, paymentProfile },
        })
    }

    return (
        <Box sx={{ minHeight: '100vh', py: 6 }}>
            <Container maxWidth="sm">

                <Typography variant="h4" fontWeight={900} mb={3}>
                    {paymentProfile?.amountLabel || 'Enter Amount'}
                </Typography>

                <Typography mb={2}>
                    Paying: <strong>{provider.business_name || provider.name}</strong>
                </Typography>

                {paymentProfile?.amountHint ? (
                    <Typography mb={2} color="text.secondary">
                        {paymentProfile.amountHint}
                    </Typography>
                ) : null}

                <Stack spacing={3}>
                    <TextField
                        label={paymentProfile?.amountLabel || 'Amount'}
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        fullWidth
                    />

                    <Button
                        variant="contained"
                        onClick={goConfirm}
                        disabled={!amount}
                    >
                        Continue
                    </Button>
                </Stack>

            </Container>
        </Box>
    )
}

export default PaymentAmount
